// extracted by mini-css-extract-plugin
module.exports = {"sidebar_open":"style_sidebar_open__H8zQz","sidebar_closed":"style_sidebar_closed__tb5Fd"};